import React from "react";
import { CBlock, IPMBlock } from "../../../../models/IPages";
import { Editor } from "../../../../components/UI/editor/QuillEditor";

function ContentBlock({ data, setData, articles, categoryType, actionData }: IPMBlock) {

  const ContentBlockHandler = (val: string, type: keyof CBlock) =>
  setData((prev: any) => {
    return { ...prev, [type]: val };
  });

  return (
    <>
      <div className="step-list col">
          <div className="title">Content Block</div>
          <Editor
          value={data?.description}
          onChange={(val) => ContentBlockHandler(val, 'description')}         
            placeholder="Enter content"
          style={{
            height: "40vh",
            marginBottom: "3rem",
          }}
          readOnly={!actionData?.add && !actionData?.edit}
          />
      </div>
    </>
  );
}

export default ContentBlock;
